import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import './Layout.css';
import FreioLabsLogo from '../assets/logo/FL-Logo-Blue-Circle-Bold-White-Beaker.png';
import NerdyBot from './NerdyBot';

const Layout: React.FC = () => {
  return (
    <div className="layout">
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="nav-logo">
            <img src={FreioLabsLogo} alt="FreioLabs" />
            <span>FreioLabs</span>
          </Link>
          <div className="nav-links">
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/about" className="nav-link">About</Link>
            <Link to="/services" className="nav-link">Services</Link>
            <Link to="/contact" className="nav-link">Contact</Link>
          </div>
        </div>
      </nav>
      
      <main className="main-content">
        <Outlet />
      </main>
      
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>FreioLabs</h4>
              <p>Innovative solutions for the future</p>
            </div>
            <div className="footer-section">
              <h4>Legal</h4>
              <Link to="/terms" className="footer-link">Terms & Conditions</Link>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/liability" className="footer-link">Release of Liability</Link>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>legal@freiolabs.com</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 FreioLabs. All rights reserved.</p>
          </div>
        </div>
      </footer>
      <NerdyBot />
    </div>
  );
};

export default Layout;